export enum VivaAPIType {
  account = 'IWsAPIAccount',
  accountFinancial = 'IWsAPIAccountFinancial',
  capacity = 'IWsAPICapacity',
  event = 'IWsAPIEvent',
  mask = 'IWsAPIMask',
  order = 'IWsAPIOrder',
  performance = 'IWsAPIPerformance',
  priceList = 'IWsAPIPriceList',
  product = 'IWsAPIProduct',
  promotion = 'IWsAPIPromotion',
  reservation = 'IWsAPIReservation',
  seat = 'IWsAPISeat',
  ticket = 'IWsAPITicket',
  upsell = 'IWsAPIUpsell',
  user = 'IWsAPIUser',
}

export enum VivaAPIOperation {
  //IWsAPIAccountFinancial
  ActivateFinancial = 'ActivateFinancial',
  AdvancePayment = 'AdvancePayment',
  ChangeCreditDetails = 'ChangeCreditDetails',
  CreditSettlement = 'CreditSettlement',
  SearchCredit = 'SearchCredit',
  UpdateFinancialConfig = 'UpdateFinancialConfig',
  //IWsAPIAccount
  AccountCanPay = 'AccountCanPay',
  AccountLogIn = 'AccountLogIn',
  AddAccountNote = 'AddAccountNote',
  AddMediaToAccount = 'AddMediaToAccount',
  B2BAccountLogIn = 'B2BAccountLogIn',
  ChangeAccountCategory = 'ChangeAccountCategory',
  ChangeAccountPassword = 'ChangeAccountPassword',
  ChangeAccountStatus = 'ChangeAccountStatus',
  FindAccountSaleByDate = 'FindAccountSaleByDate',
  GetAccountCSV = 'GetAccountCSV',
  ManageAccountGiftAid = 'ManageAccountGiftAid',
  ManageAccountRelationship = 'ManageAccountRelationship',
  MergeAccount = 'MergeAccount',
  PrintAccountPDF = 'PrintAccountPDF',
  ReadAccountByAK = 'ReadAccountByAK',
  ReadAccountByID = 'ReadAccountByID',
  ReadAccountHierarchy = 'ReadAccountHierarchy',
  ReadAccountHistoryByAK = 'ReadAccountHistoryByAK',
  ReadAccountSaleHierarchy = 'ReadAccountSaleHierarchy',
  ReadAccountTicketsByAk = 'ReadAccountTicketsByAk',
  ReadSaleRestriction = 'ReadSaleRestriction',
  ResetAccountPassword = 'ResetAccountPassword',
  SaveAccount = 'SaveAccount',
  SearchAccount = 'SearchAccount',
  SearchTotalsByStatisticalGroup = 'SearchTotalsByStatisticalGroup',
  UnmergeAccount = 'UnmergeAccount',
  //IWsAPIEvent
  FindAllEventCategory = 'FindAllEventCategory',
  FindAllEvents = 'FindAllEvents',
  FindEventsByAccountAK = 'FindEventsByAccountAK',
  ReadEventByAK = 'ReadEventByAK',
  ReadEventByCode = 'ReadEventByCode',
  SearchEvent = 'SearchEvent',
  //IWsAPIMask
  FindAllAccountCategories = 'FindAllAccountCategories',
  ReadAccountCategoryByAK = 'ReadAccountCategoryByAK',
  ReadAccountCategoryByCode = 'ReadAccountCategoryByCode',
  ReadAttachmentByAK = 'ReadAttachmentByAK',
  ReadDataProviderByCode = 'ReadDataProviderByCode',
  ReadExtendedInfoByAK = 'ReadExtendedInfoByAK',
  ReadExtendedInfoByCode = 'ReadExtendedInfoByCode',
  ReadImageByAK = 'ReadImageByAK',
  SearchDataMask = 'SearchDataMask',
  //IWsAPIOrder
  AbortSale = 'AbortSale',
  ActivateTicketPackage = 'ActivateTicketPackage',
  AddExternalPackage = 'AddExternalPackage',
  AddOrderNote = 'AddOrderNote',
  AddPackage = 'AddPackage',
  ApproveAccountTicket = 'ApproveAccountTicket',
  CheckBasket = 'CheckBasket',
  CheckOut = 'CheckOut',
  CheckOut2 = 'CheckOut2',
  CheckSuggestiveSell = 'CheckSuggestiveSell',
  CloseBulkOrder = 'CloseBulkOrder',
  CloseMultipleOrder = 'CloseMultipleOrder',
  CloseMultipleOrder2 = 'CloseMultipleOrder2',
  CloseOrder = 'CloseOrder',
  SearchReservation = 'SearchReservation',
  DeleteReservation = 'DeleteReservation',
  DeleteReservationCredit = 'DeleteReservationCredit',
  DepositOnReservation = 'DepositOnReservation',
  FindSaleByExternalMedia = 'FindSaleByExternalMedia',
  GenerateReferralCode = 'GenerateReferralCode',
  MoneyCardCashOut = 'MoneyCardCashOut',
  MoneyCardRecharge = 'MoneyCardRecharge',
  PreSale = 'PreSale',
  ReadOrderByAK = 'ReadOrderByAK',
  ReadTransactionBySale = 'ReadTransactionBySale',
  Renew = 'Renew',
  TransferPerformance = 'TransferPerformance',
  TryDeleteReservation = 'TryDeleteReservation',
  TryDeleteReservationCredit = 'TryDeleteReservationCredit',
  TryRenew = 'TryRenew',
  TryTransferPerformance = 'TryTransferPerformance',
  TryUpgrade = 'TryUpgrade',
  Upgrade = 'Upgrade',
  ValidateExternalPackage = 'ValidateExternalPackage',
  ValidatePackage = 'ValidatePackage',
  VoidTicket = 'VoidTicket',
  //IWsAPIPerformance
  ChangePerformanceStatus = 'ChangePerformanceStatus',
  FindAllPerformanceByCategories = 'FindAllPerformanceByCategories',
  FindAllPerformanceProductByAk = 'FindAllPerformanceProductByAk',
  FindAllPerformanceProductByAkV2 = 'FindAllPerformanceProductByAkV2',
  FindPerformanceCapacityAndProduct = 'FindPerformanceCapacityAndProduct',
  FindPerformanceCapacityByAk = 'FindPerformanceCapacityByAk',
  GetCalendarAvailability = 'GetCalendarAvailability',
  ReadPerformanceByAK = 'ReadPerformanceByAK',
  ReadPerformanceByDate = 'ReadPerformanceByDate',
  ReadSpaceStructureByAK = 'ReadSpaceStructureByAK',
  SearchCalendarAvailability = 'SearchCalendarAvailability',
  GetDaysAvailability = 'GetDaysAvailability',
  GetDayPerformances = 'GetDayPerformances',
  SearchPerformance = 'SearchPerformance',
  SearchPerformanceEntries = 'SearchPerformanceEntries',
  SetPerformancePrice = 'SetPerformancePrice',
  //IWsAPIPriceList
  ReadPriceListByAk = 'ReadPriceListByAk',
  ReadPriceListById = 'ReadPriceListById',
  //IWsAPIProduct
  ActivateProductByAK = 'ActivateProductByAK',
  DeactivateProductByAK = 'DeactivateProductByAK',
  FindAccountProduct = 'FindAccountProduct',
  FindAllProductByStatGroup = 'FindAllProductByStatGroup',
  FindAllProducts = 'FindAllProducts',
  FindAllStatisticalGroup = 'FindAllStatisticalGroup',
  FindB2BAccountProduct = 'FindB2BAccountProduct',
  ImportProduct = 'ImportProduct',
  ReadProductByAK = 'ReadProductByAK',
  ReadProductByID = 'ReadProductByID',
  ReadProductDimensionByAK = 'ReadProductDimensionByAK',
  ReadStatisticalGroupByCode = 'ReadStatisticalGroupByCode',
  SearchProduct = 'SearchProduct',
  UpdateProduct = 'UpdateProduct',
  // IWsAPIPromotion
  ValidateCouponCode = 'ValidateCouponCode',
  ReadExternalPackageByCode = 'ReadExternalPackageByCode',
  //IWsAPISeat
  HoldSeat = 'HoldSeat',
  ReleaseSeat = 'ReleaseSeat',
  SeatInfo = 'SeatInfo',
  //IWsAPITicket
  AddTicketNoteById = 'AddTicketNoteById',
  AddTicketNoteByMediaCode = 'AddTicketNoteByMediaCode',
  BlockMediaByMediaCode = 'BlockMediaByMediaCode',
  BlockTicketById = 'BlockTicketById',
  BlockTicketByMediaCode = 'BlockTicketByMediaCode',
  ChangeAccount = 'ChangeAccount',
  ChangePerformance = 'ChangePerformance',
  ChangePerformanceMultipleTickets = 'ChangePerformanceMultipleTickets',
  ChangePerformanceSimple = 'ChangePerformanceSimple',
  FindAllTicketPackages = 'FindAllTicketPackages',
  GenerateWallet = 'GenerateWallet',
  PrintPdfTicket = 'PrintPdfTicket',
  PrintPdfTicketSinglePage = 'PrintPdfTicketSinglePage',
  ReadPerformanceTicket = 'ReadPerformanceTicket',
  ReadPerformanceTicketFull = 'ReadPerformanceTicketFull',
  ReadRedeemableEntitlement = 'ReadRedeemableEntitlement',
  ReadRedeemableProduct = 'ReadRedeemableProduct',
  ReadRenewInfo = 'ReadRenewInfo',
  ReadRenewInfoByMediaCode = 'ReadRenewInfoByMediaCode',
  ReadTicketById = 'ReadTicketById',
  ReadTicketByMediaCode = 'ReadTicketByMediaCode',
  ReadTicketExtendedInfoByAK = 'ReadTicketExtendedInfoByAK',
  ReadTicketUsageById = 'ReadTicketUsageById',
  ReadTicketUsageByMediaCode = 'ReadTicketUsageByMediaCode',
  ReadUpgradeInfo = 'ReadUpgradeInfo',
  ReadUpgradeInfoByMediaCode = 'ReadUpgradeInfoByMediaCode',
  RedeemProduct = 'RedeemProduct',
  ReleasePerformance = 'ReleasePerformance',
  SaveExtendedInfo = 'SaveExtendedInfo',
  SearchTicket = 'SearchTicket',
  SwapMedia = 'SwapMedia',
  SwapMultipleMedia = 'SwapMultipleMedia',
  UnBlockMediaByMediaCode = 'UnBlockMediaByMediaCode',
  UnBlockTicketById = 'UnBlockTicketById',
  UnBlockTicketByMediaCode = 'UnBlockTicketByMediaCode',
  UpdateTicketValidityById = 'UpdateTicketValidityById',
  UpdateTicketValidityByMediaCode = 'UpdateTicketValidityByMediaCode',
  VoidRedeemProduct = 'VoidRedeemProduct',
  WhiteListTicket = 'WhiteListTicket',
  //IWsAPIUpsell
  CheckShopCartUpsell = 'CheckShopCartUpsell',
  FindAllUpsell = 'FindAllUpsell',
  FindUpsellByProductAK = 'FindUpsellByProductAK',
  ReadUpsellByAK = 'ReadUpsellByAK',
  SearchUpsell = 'SearchUpsell',
  //IWsAPIUser
  CheckSession = 'CheckSession',
  FindAllPaymentMethod = 'FindAllPaymentMethod',
  ReadPaymentMethodByAk = 'ReadPaymentMethodByAk',
  ResetISAPICache = 'ResetISAPICache',
  SaveUser = 'SaveUser',
  SearchUser = 'SearchUser',
  SearchUserRole = 'SearchUserRole',
  UserLogin = 'UserLogin',
  UserLogout = 'UserLogout',
}
